import { BuyerCompany } from './../../../dto/buyer/buyer-company.entity';
import { BUYER_ROLE, BUYER_STATUS } from '../../../shared/common-code.type';
import { BaseDto } from '../../../core';

export class BaseUser extends BaseDto<BaseUser> {
  constructor(user: any) {
    super(user);
  }

  id: number;
  userId: number;
  email: string;

  firstName: string;

  lastName: string;
  buyerStatus: BUYER_STATUS[];
  userRoles: BUYER_ROLE[];
  isCertified: boolean;
  invalidCampaign: boolean;

  buyerCompany: BuyerCompany;
  purchaseOrderCount: number;

  isApproved() {
    return this.userRoles.includes(BUYER_ROLE.BUYER_APPROVED);
  }
}
